import React from "react";

interface BadgeIconProps {
  className?: string;
  withBorder?: boolean;
  tier?: string;
  imageClassName?: string;
}

const TierBadge: React.FC<BadgeIconProps> = (props) => {
  if (props.tier === "hidden") {
    return <div className={`${props.className}`}></div>;
  }

  if (props.tier) {
    return (
      <span className={`${props.className} text-primaryText`}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className={props.imageClassName}
          src={`/icons/tiers/${props.tier}.svg`}
          alt={props.tier}
        />
      </span>
    );
  }

  return (
    <span className={`${props.className} text-primaryText`}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className={props.imageClassName}
        src="/icons/tiers/locked.svg"
        alt="locked"
      />
    </span>
  );
};

export default React.memo(TierBadge);
